import styled from 'styled-components';

interface ITypographyProps extends React.HTMLAttributes<HTMLElement> {
  margin?: string;
  textAlign?: string;
  fontSize?: string;
  alignSelf?: string;
}

export const H1 = styled.h1<ITypographyProps>`
  margin: ${props => (props.margin ? props.margin : '0px 0px 5px 0px')};
  font-size: 36px;
  font-family: LexiaRegular;
  letter-spacing: 0.4px;
  font-weight: '300';
  align-self: center;
`;

export const H2 = styled.h2<ITypographyProps>`
  text-align: ${props => (props.textAlign ? props.textAlign : 'left')};
  font-family: EffraBold;
  font-size: 14pt;
  color: ${props => (props.color ? props.color : '#000')};
  margin: ${props => (props.margin ? props.margin : '0px 0px 10px 0px')};
`;

export const H3 = styled.h3<ITypographyProps>`
  font-family: EffraRegular;
  font-size: 14pt;
  color: ${props => (props.color ? props.color : '#000')};
  text-align: ${props => (props.textAlign ? props.textAlign : 'left')};
  margin: ${props => (props.margin ? props.margin : '0px 0px 10px 0px')};
`;

export const P = styled.p<ITypographyProps>`
  font-family: EffraLight;
  font-size: 14pt;
  color: ${props => (props.color ? props.color : '#000')};
  margin: ${props => (props.margin ? props.margin : 'unset')};
`;

export const A = styled.a<ITypographyProps>`
  cursor: pointer;
  font-family: EffraBold;
  font-size: ${props => (props.fontSize ? props.fontSize : '14pt')};
  align-self: ${props => (props.alignSelf ? props.alignSelf : 'center')};
  color: ${props => (props.color ? props.color : '#fff')};
  margin: ${props => (props.margin ? props.margin : 'unset')};
  text-decoration: none;
`;

export const HeaderH1 = styled(H1)<ITypographyProps>`
  @media only screen and (min-width: 768px) {
    margin-left: 20px;
    font-size: 36px;
  }

  @media only screen and (max-width: 768px) {
    margin-left: 0px;
    font-size: 20px;
  }
`;
